module.exports = __webpack_public_path__ + "static/media/skybox_internal_facility_pc.f00a4adb.jpg";